import React from 'react';
import { Grid, Skeleton } from '@mui/material';
import { styled } from '@mui/system';
import { AIIndividualComponentLoader } from './AIComponentLoadingSkeleton';

const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
  borderRadius: '4px',
  background: theme.palette.action.hover,
}));

export const ComponentLoadingSkeleton = () => {
  return (
    <Grid container paddingLeft={'16px'} paddingRight={'16px'} paddingTop={'24px'}>
      <Grid container marginBottom={'24px'} spacing={5}>
        <Grid item xs={5}>
          <StyledSkeleton variant={'rectangular'} height={'40px'} width={'100%'} />
        </Grid>
        <Grid item xs></Grid>
        <Grid item xs={1}>
          <StyledSkeleton variant={'rectangular'} height={'40px'} width={'100%'} />
        </Grid>
        <Grid item xs={1}>
          <StyledSkeleton variant={'rectangular'} height={'40px'} width={'100%'} />
        </Grid>
      </Grid>
      <Grid item xs={10} paddingRight={'32px'}>
        <IndividualComponentLoader />
      </Grid>
      <Grid item xs={2}>
        <StyledSkeleton variant={'rectangular'} height={'90vh'} width={'100%'} />
      </Grid>
    </Grid>
  );
};

export const IndividualComponentLoader = ({
  isAIEditing,
  componentType,
  componentName,
  componentDescription,
  componentData,
  ...props
}) => {
  // Use AI skeleton if in AI editing mode, otherwise use regular skeleton
  if (isAIEditing) {
    return (
      <AIIndividualComponentLoader
        componentType={componentType}
        componentName={componentName}
        componentDescription={componentDescription}
        componentData={componentData}
        {...props}
      />
    );
  }
  return <StyledSkeleton variant={'rectangular'} height={'90vh'} width={'100%'} />;
};
